<template>
    <div>
        <div
            class="grid_height flex mt-2"
            v-for="item in statedata"
            :key="item.id"
        >
            <div class="flex">
                <v-radio-group v-model="radioGroup" row>
                    <div class="flex">
                        <v-radio
                            @click="handleclick(item.id)"
                            background-color="white"
                            hide-details
                            color="success"
                            :value="item.id"
                            :label="capitalizeFirstLetter(item.eng_name)"
                        />
                    </div>
                </v-radio-group>
            </div>
        </div>
    </div>
</template>


<script>
import { mapActions } from "vuex";

export default {
    ...mapActions("StateFilterStore", ["addstatedata", "GET_STATE_ID"]),
    name: "checkboxitem",
    props: {
        statedata: Array,
    },
    data() {
        return {
            checkbox: true,
            stateid: "",
            storedata: [],
            radioGroup: null,
        };
    },
    methods: {
        capitalizeFirstLetter(string) {
            var str = string.toLowerCase();
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        handleclick(id) {
            if (this.checkbox) {
                console.log("Called Add");
                this.$emit("addstateid", id);
            } else {
                console.log("Called Remove");
                this.$emit("removestateid", id);
            }
        },
        checkCheckbox() {
            this.storedata =
                this.$store.getters["StateFilterStore/GET_STATE_ID"];
            if (this.storedata.length > 0) {
                this.radioGroup = this.storedata[0];
            }
        },
    },
    mounted() {
        this.checkCheckbox();
    },
};
</script>


<style scoped>
.grid_height {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0px;
    background-color: white;
    width: 100%;
    justify-content: left;
    height: 27px;
    border-radius: 2px;
}
.location {
    column-gap: 8px;
    width: 30%;
    justify-content: start;
}
.checkbox {
    width: 30px;
    height: 30px;
}
.v-input--selection-controls {
    margin-top: 6px;
}
.location-item {
    margin: 0px;
}
.v-application p {
    margin-top: 6px;
    font-size: 0.9rem;
    margin-bottom: 0px;
}
</style>